import repository from '@/api/Main/notifications'

export default {
    state: {
        notifications:    [],
        unread_count:     0,
        notifications_loading: false,
        polling_interval: null,
    },

    getters: {
        GET_NOTIFICATIONS:              (state) => state.notifications,
        GET_UNREAD_COUNT:               (state) => state.unread_count,
        GET_APPROVAL_NOTIFICATIONS:     (state) => state.notifications.filter(n => n.type === 'approval'),
        GET_ANNOUNCEMENT_NOTIFICATIONS: (state) => state.notifications.filter(n => n.type === 'announcement'),
        GET_REMINDER_NOTIFICATIONS:     (state) => state.notifications.filter(n => n.type === 'reminder'),
        NOTIFICATIONS_LOADING:          (state) => state.notifications_loading,
    },

    mutations: {
        SET_NOTIFICATIONS(state, { data, unread_count }) {
            state.notifications = data.data || []
            state.unread_count  = unread_count || 0
        },
        MARK_NOTIFICATION_READ(state, id) {
            const n = state.notifications.find(n => n.id === id)
            if (n && !n.read_at) {
                n.read_at = new Date().toISOString()
                state.unread_count = Math.max(0, state.unread_count - 1)
            }
        },
        MARK_ALL_NOTIFICATIONS_READ(state, type) {
            state.notifications.forEach(n => {
                if (!n.read_at && (!type || n.type === type)) {
                    n.read_at = new Date().toISOString()
                }
            })
            if (type) {
                state.unread_count = state.notifications.filter(n => !n.read_at).length
            } else {
                state.unread_count = 0
            }
        },
        REMOVE_NOTIFICATION(state, id) {
            const idx = state.notifications.findIndex(n => n.id === id)
            if (idx !== -1) {
                if (!state.notifications[idx].read_at) {
                    state.unread_count = Math.max(0, state.unread_count - 1)
                }
                state.notifications.splice(idx, 1)
            }
        },
        CLEAR_ALL_NOTIFICATIONS(state, type) {
            if (type) {
                const removed = state.notifications.filter(n => n.type === type && !n.read_at).length
                state.notifications = state.notifications.filter(n => n.type !== type)
                state.unread_count  = Math.max(0, state.unread_count - removed)
            } else {
                state.notifications = []
                state.unread_count  = 0
            }
        },
        SET_NOTIFICATIONS_LOADING(state, val) { state.notifications_loading = val },
        SET_POLLING_INTERVAL(state, interval) { state.polling_interval = interval },
    },

    actions: {
        async fetchNotifications({ commit }, params = {}) {
            commit('SET_NOTIFICATIONS_LOADING', true)
            try {
                const res = await repository.index(params)
                commit('SET_NOTIFICATIONS', {
                    data:         res.data.data,
                    unread_count: res.data.unread_count,
                })
            } catch (e) {
                // Silent fail — bell stays at last known state
            } finally {
                commit('SET_NOTIFICATIONS_LOADING', false)
            }
        },

        async markNotificationRead({ commit }, id) {
            commit('MARK_NOTIFICATION_READ', id)
            try { await repository.markRead(id) } catch (e) { /* */ }
        },

        async markAllNotificationsRead({ commit }, type = null) {
            commit('MARK_ALL_NOTIFICATIONS_READ', type)
            try { await repository.markAllRead(type ? { type } : {}) } catch (e) { /* */ }
        },

        async clearNotification({ commit }, id) {
            commit('REMOVE_NOTIFICATION', id)
            try { await repository.clear(id) } catch (e) { /* */ }
        },

        async clearAllNotifications({ commit }, type = null) {
            commit('CLEAR_ALL_NOTIFICATIONS', type)
            try { await repository.clearAll(type ? { type } : {}) } catch (e) { /* */ }
        },

        startNotificationPolling({ dispatch, state, commit }) {
            if (state.polling_interval) return
            dispatch('fetchNotifications')
            const interval = setInterval(() => dispatch('fetchNotifications'), 60000)
            commit('SET_POLLING_INTERVAL', interval)
        },

        stopNotificationPolling({ state, commit }) {
            if (state.polling_interval) {
                clearInterval(state.polling_interval)
                commit('SET_POLLING_INTERVAL', null)
            }
        },
    },
}
